import Rollbar from 'rollbar';

const rollbar = new Rollbar({
    accessToken: process.env.MIX_ROLLBAR_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    source_map_enabled: true,
    environment: process.env.MIX_APP_ENV,
    payload: {
        client: {
            javascript: {
                code_version: '1.0'
            }
        }
    }
});

export default {
  install(app) {
    app.config.errorHandler = (error, vm, info) => {
        console.log('Catching error', error, vm, info);
        console.error(error, vm, info);
        rollbar.error(error, { info });
    };
    app.provide('rollbar', rollbar);
  },
};